import Form      from 'Scripts/common/form';
import Loqate    from 'Scripts/donate-form/loqate.js';
import TomSelect from 'Vendor/tom-select/dist/js/tom-select.base.js';

export default class VatInfoForm {
	constructor() {
		this.form = new Form({
			form: $("#js-vat-info-form"),
			callback: this.onFormSubmitSuccess.bind(this),
			willRedirect: true,
		});

		// Setup country dropdown
		var selectOpts = {
			closeAfterSelect: true,
			duplicates: true,
			hideSelected: false,
			highlight: false,
			lockOptgroupOrder: true,
			maxOptions: null,
		}
		var tsCountry = new TomSelect(document.getElementById("address.country"), selectOpts);

		// Hack to stop auto-complete messing with the input inside TomSelect
		$(".ts-control").find("input").attr('autocomplete', 'new-password');

		// Set up Loqate
		new Loqate({ input: $("#loqate"), countryInput: tsCountry, enterManuallyBtn: $("#js-manual-address") });
	}

	onFormSubmitSuccess(resp) {
		window.location.href = resp.payload.redirectUrl;
	}
}